import { Box } from '@mui/material';
import { BlockMaskImage } from 'components/UI';
import CustomInfoBlock from 'components/UI/CustomInfoBlock/CustomInfoBlock';
import { useChangeFromMedia } from 'common/helpers';
import classes from './TeachersMentors.module.scss';


const TeachersMentors = ({ data, title }) => {
  const swiperOpts = useChangeFromMedia(
    { slidesPerView: 3, spaceBetween: 0 },
    { slidesPerView: 1.2, spaceBetween: 0 },
    { slidesPerView: 2.5, spaceBetween: 0 },
    { slidesPerView: 1.2, spaceBetween: 10 },
    { slidesPerView: 2.145, spaceBetween: 0 },
  );
  const isButtons = useChangeFromMedia(false, true, true, true, false);
  return (
    <Box className={classes.main}>
      <Box className={classes.sliderWrapper}>
        <CustomInfoBlock
          text={title}
          swiperOpts={swiperOpts}
          isButtons={isButtons}
        >
          {
            data?.map((item) => (
              <BlockMaskImage
                key={item.name}
                name={item.name}
                info = {item.info}
                image = {item.image}
                image_alt={item.image_alt}
              />
            ))
          }
        </CustomInfoBlock>
      </Box>
    </Box>
  );
};
export default TeachersMentors;
